import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class ClassifiedsBreadcrumb extends Component {
  view() {
    const discussion = this.attrs.discussion;
    const tags = discussion.tags?.() || [];
    const crumbs = [];
    tags.filter(t => t && typeof t.isClassifieds === 'function' && t.isClassifieds()).forEach(tag => {
      crumbs.push({
        label: tag.name?.(),
        href: app.route('tag', {
          tags: tag.slug?.()
        })
      });
    });
    crumbs.push({
      label: discussion.title()
    });
    if (crumbs.length === 0) return null;
    return m("nav", {
      className: "ClassifiedsBreadcrumb",
      "aria-label": "Breadcrumb"
    }, m("ol", {
      className: "ClassifiedsBreadcrumb-list"
    }, crumbs.map((c, i) => m("li", {
      key: i,
      className: "ClassifiedsBreadcrumb-item"
    }, c.href ? m("a", {
      className: "ClassifiedsBreadcrumb-link",
      href: c.href,
      config: m.route.link
    }, c.label) : m("span", {
      className: "ClassifiedsBreadcrumb-current"
    }, c.label), i < crumbs.length - 1 && m("i", {
      className: "fas fa-chevron-right ClassifiedsBreadcrumb-sep",
      "aria-hidden": "true"
    })))));
  }
}
flarum.reg.add('ramon-classifieds', 'forum/components/ClassifiedsBreadcrumb', ClassifiedsBreadcrumb);